/* eslint-disable react-hooks/exhaustive-deps */
import DialogTitle from "@mui/material/DialogTitle";
import Dialog from "@mui/material/Dialog";
import {
  Box,
  Button,
  DialogActions,
  DialogContent,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
  Divider,
  Paper,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { organizationPrimaryColors } from "../../../../layouts/PermanentSidebarMUI";
import { useOrgan } from "../../../../hooks/useOrgan";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import useBaseService from "../../../../hooks/services/useBaseService";
import useLoader from "../../../../hooks/useLoader";
import { entities } from "../../../../constants/entities";
import { DeleteOutline, BuildOutlined } from "@mui/icons-material";
import { useCallback, useState } from "react";
import useNotification from "../../../../hooks/useNotification";
import dayjs from "dayjs";

export const DisposeModal = ({ data, open, onClose }) => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const { showNotification } = useNotification();

  const [option, setOption] = useState("dispose");

  const {
    post: baseServicePost,
    put: baseServicePut,
    del: baseServiceDelete,
  } = useBaseService(navigate);
  const { hideLoader, showLoader } = useLoader();

  const { selectedOrgan } = useOrgan();
  const primaryColor = selectedOrgan?.name
    ? organizationPrimaryColors[selectedOrgan.name.toUpperCase()] ||
      organizationPrimaryColors.ALUCOM
    : organizationPrimaryColors.ALUCOM;

  const refreshList = useCallback(() => {
    queryClient.invalidateQueries(["equipments"]);
  }, [queryClient]);

  const makeAvailableEquipmentMutation = useMutation({
    mutationFn: async (productId) => {
      showLoader();
      const response = await baseServicePut(
        entities.equipments.makeAvailable(productId),
      );
      return response.result;
    },
    onSuccess: () => {
      refreshList();
      handleClose();
    },
    onError: (err) => {
      console.error("onError ", err);
      hideLoader();
    },
  });

  const disposeMutation = useMutation({
    mutationFn: async (productId) => {
      showLoader();
      const response = await baseServiceDelete(
        entities.equipments.delete(productId),
      );
      return response.result;
    },
    onSuccess: () => {
      refreshList();
      handleClose();
    },
    onError: (err) => {
      console.error("onError ", err);
      hideLoader();
    },
  });

  const reviewMutation = useMutation({
    mutationFn: async () => {
      showLoader();
      const response = await baseServicePost(entities.maintenances.create, {
        maintenance: {
          maintenance_date: dayjs().format("YYYY-MM-DD HH:mm:ss"),
          equipment_id: data.id,
          details:
            "Após a revisão realizada por Dona Delne, o equipamento foi encaminhado para nova análise.",
        },
      });
      return response.result;
    },
    onSuccess: () => {
      refreshList();
      handleClose();
    },
    onError: (err) => {
      console.error("onError ", err);
      hideLoader();
    },
  });

  const handleSubmit = async () => {
    try {
      if (!data) {
        showNotification("error", "Nenhum equipamento selecionado");
        return;
      }

      switch (option) {
        case "dispose":
          return await disposeMutation.mutateAsync(data.id);
        case "makeAvailable":
          return await makeAvailableEquipmentMutation.mutateAsync(data.id);
        case "review":
          return await reviewMutation.mutateAsync();
        default:
          return;
      }
    } catch (error) {
      console.error("Erro ao disponibilizar equipamento:", {
        status: error.status,
        message: error.message,
      });
    }
  };

  const handleClose = () => {
    onClose();
    setOption("dispose");
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="md"
      fullWidth
      disableEnforceFocus
      PaperProps={{
        sx: {
          borderRadius: 2,
        },
      }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          backgroundColor: primaryColor,
          color: "#FFFFFF",
          py: 2,
          px: 3,
        }}>
        <DialogTitle sx={{ fontWeight: "bold", p: 0 }}>
          Disponibilizar Equipamento
        </DialogTitle>
      </Box>

      <DialogContent sx={{ pt: 3, pb: 2 }}>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
          Selecione uma das opções abaixo para definir o destino do equipamento:
        </Typography>

        <FormControl component="fieldset" sx={{ width: "100%" }}>
          <RadioGroup
            aria-labelledby="tipo-acao"
            name="tipo-acao"
            value={option}
            defaultValue={"dispose"}
            onChange={(e) => setOption(e.target.value)}>
            {/* Opção 1: Liberar para locação */}
            {/* <Paper
              elevation={0}
              sx={{
                p: 2,
                mb: 2,
                border: "1px solid",
                borderColor: "divider",
                borderRadius: 2,
                transition: "all 0.2s",
                "&:hover": {
                  borderColor: "primary.main",
                  backgroundColor: "action.hover",
                },
              }}>
              <Box sx={{ display: "flex", alignItems: "flex-start" }}>
                <FormControlLabel
                  value="makeAvailable"
                  control={<Radio />}
                  label={
                    <Box sx={{ ml: 1 }}>
                      <Box
                        sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                        <CheckCircleOutline color="success" fontSize="small" />
                        <Typography variant="subtitle1" fontWeight="600">
                          Liberar para locação
                        </Typography>
                      </Box>
                      <Typography
                        variant="body2"
                        color="text.secondary"
                        sx={{ mt: 0.5 }}>
                        Libera automaticamente o equipamento, tornando-o
                        disponível para novas requisições.
                      </Typography>
                    </Box>
                  }
                  sx={{ m: 0, width: "100%" }}
                />
              </Box>
            </Paper> */}

            {/* Opção 2: Baixar equipamento */}
            <Paper
              elevation={0}
              sx={{
                p: 2,
                mb: 2,
                border: "1px solid",
                borderColor: "divider",
                borderRadius: 2,
                transition: "all 0.2s",
                "&:hover": {
                  borderColor: "error.main",
                  backgroundColor: "action.hover",
                },
              }}>
              <Box sx={{ display: "flex", alignItems: "flex-start" }}>
                <FormControlLabel
                  value="dispose"
                  control={<Radio />}
                  label={
                    <Box sx={{ ml: 1 }}>
                      <Box
                        sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                        <DeleteOutline color="error" fontSize="small" />
                        <Typography variant="subtitle1" fontWeight="600">
                          Baixar equipamento
                        </Typography>
                      </Box>
                      <Typography
                        variant="body2"
                        color="text.secondary"
                        sx={{ mt: 0.5 }}>
                        Remove do estoque, exclui o tombo e registra a baixa
                        definitiva do equipamento.
                      </Typography>
                    </Box>
                  }
                  sx={{ m: 0, width: "100%" }}
                />
              </Box>
            </Paper>

            {/* Opção 3: Enviar para revisão */}
            <Paper
              elevation={0}
              sx={{
                p: 2,
                border: "1px solid",
                borderColor: "divider",
                borderRadius: 2,
                transition: "all 0.2s",
                "&:hover": {
                  borderColor: "warning.main",
                  backgroundColor: "action.hover",
                },
              }}>
              <Box sx={{ display: "flex", alignItems: "flex-start" }}>
                <FormControlLabel
                  value="review"
                  control={<Radio />}
                  label={
                    <Box sx={{ ml: 1 }}>
                      <Box
                        sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                        <BuildOutlined color="warning" fontSize="small" />
                        <Typography variant="subtitle1" fontWeight="600">
                          Enviar para revisão
                        </Typography>
                      </Box>
                      <Typography
                        variant="body2"
                        color="text.secondary"
                        sx={{ mt: 0.5 }}>
                        Encaminha o equipamento para manutenção novamente para
                        uma segunda avaliação técnica.
                      </Typography>
                    </Box>
                  }
                  sx={{ m: 0, width: "100%" }}
                />
              </Box>
            </Paper>
          </RadioGroup>
        </FormControl>

        <Divider sx={{ my: 2 }} />

        <Box
          sx={{
            p: 2,
            backgroundColor: "info.lighter",
            borderRadius: 1,
            border: "1px solid",
            borderColor: "info.light",
          }}>
          <Typography
            variant="caption"
            color="info.dark"
            sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
            <strong>Importante:</strong> Esta ação não pode ser desfeita.
            Certifique-se de selecionar a opção correta.
          </Typography>
        </Box>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button
          onClick={onClose}
          color="inherit"
          variant="outlined"
          sx={{ minWidth: 100 }}>
          Cancelar
        </Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          color="primary"
          sx={{ minWidth: 100 }}>
          Confirmar
        </Button>
      </DialogActions>
    </Dialog>
  );
};
